export default __webpack_public_path__ + "static/media/photo_right_1.7ff6fab0.png";